module.exports = __webpack_public_path__ + "img/7minutos3.3cd7d7e2.jpg";